import { AbstractControl } from '@angular/forms';
import { DocumentUtils } from 'app/shared/utils/document.utils';
import { EDocumentType } from 'app/shared/enums/document-type.enum';

export class CustomValidator {
    // Number only validation
    static numeric(control: AbstractControl) {
        let val = control.value;

        if (val === null || val === '') return null;

        if (!val.toString().match(/^[0-9]+(\.?[0-9]+)?$/)) return { invalidNumber: true };

        return null;
    }

    static validateCPF_CNPJ(control: AbstractControl): {
        [key: string]: boolean;
    } | null {
        const validation = {
            validateCPF(cpf) {
                cpf = cpf.replace(/-|\.|\//g, '');
                var sum;
                var remainder;
                sum = 0;
                if (cpf == '00000000000') return false;

                for (let i = 1; i <= 9; i++) sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
                remainder = (sum * 10) % 11;

                if (remainder == 10 || remainder == 11) remainder = 0;
                if (remainder != parseInt(cpf.substring(9, 10))) return false;

                sum = 0;
                for (let i = 1; i <= 10; i++) sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);
                remainder = (sum * 10) % 11;

                if (remainder == 10 || remainder == 11) remainder = 0;
                if (remainder != parseInt(cpf.substring(10, 11))) return false;
                return true;
            },

            validateCnpj(cnpj) {
                cnpj = cnpj.replace(/[^\d]+/g, '');

                if (cnpj == '') return false;

                if (cnpj.length != 14) return false;

                if (
                    cnpj == '00000000000000' ||
                    cnpj == '11111111111111' ||
                    cnpj == '22222222222222' ||
                    cnpj == '33333333333333' ||
                    cnpj == '44444444444444' ||
                    cnpj == '55555555555555' ||
                    cnpj == '66666666666666' ||
                    cnpj == '77777777777777' ||
                    cnpj == '88888888888888' ||
                    cnpj == '99999999999999'
                )
                    return false;

                let size = cnpj.length - 2;
                let numbers = cnpj.substring(0, size);
                let digits = cnpj.substring(size);
                let sum = 0;
                let pos = size - 7;
                for (let i = size; i >= 1; i--) {
                    sum += numbers.charAt(size - i) * pos--;
                    if (pos < 2) pos = 9;
                }
                let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
                if (result != digits.charAt(0)) return false;
                size = size + 1;
                numbers = cnpj.substring(0, size);
                sum = 0;
                pos = size - 7;
                for (let i = size; i >= 1; i--) {
                    sum += numbers.charAt(size - i) * pos--;
                    if (pos < 2) pos = 9;
                }
                result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
                if (result != digits.charAt(1)) return false;

                return true;
            },
        };
        if (control.value) {
            if (validation.validateCPF(control.value)) {
                return null;
            } else if (validation.validateCnpj(control.value)) {
                return null;
            } else {
                return { invalidCpfCnpj: true };
            }
        } else {
            return null;
        }
    }

    static documentValidator(documentType: string) {
        return (control: AbstractControl) => {
            const value = control.value;
            
            if (!value) return null;
            
            if (!documentType) return null;
            
            const isValid = DocumentUtils.validateDocument(value, documentType);
            
            if (!isValid) {
                return { 
                    invalidDocument: { 
                        message: DocumentUtils.getErrorMessage(documentType),
                        type: documentType
                    } 
                };
            }
            
            return null;
        };
    }


    static cpfValidator(control: AbstractControl) {
        return CustomValidator.documentValidator(EDocumentType.CPF)(control);
    }

    static cnpjValidator(control: AbstractControl) {
        return CustomValidator.documentValidator(EDocumentType.CNPJ)(control);
    }

    static rgValidator(control: AbstractControl) {
        return CustomValidator.documentValidator(EDocumentType.RG)(control);
    }
}
